(function ($) {
  const textMax = 250;
  const counterWrapper = $('.counter');
  let counter;
  let textarea;

  if (counterWrapper) {
    counterWrapper
      .find('label')
      .after('<span class="textarea-character-count"></span>');

    counter = counterWrapper.find('span.textarea-character-count');
    textarea = counterWrapper.find('textarea');

    textarea.attr('maxlength', 250);

    counter.html(`(${textMax} karakters over)`);

    textarea.keyup(function () {
      if ($(this).parent().prev('.textarea-character-count')) {
        const textLength = $(this).val().length;
        const textRemaining = textMax - textLength;

        if (textRemaining !== 1) {
          counter.html(`(${textRemaining} karakters over)`);
        } else {
          counter.html(`(${textRemaining} karakter over)`);
        }

        if (textLength === 250) {
          counter.html('Maximaal aantal karakters bereikt!');
        }
      }
    });
  }
}(jQuery));
